import { loginRequest } from '@/modules/authentication/authConfig';
import {
  BrowserAuthError,
  BrowserAuthErrorCodes,
  InteractionRequiredAuthError,
  InteractionStatus,
} from '@azure/msal-browser';
import { useMsal } from '@azure/msal-react';
import { useCallback, useEffect, useRef } from 'react';
import { logger } from '@common/logging/logger';

export const useLoginPage = () => {
  const { instance, inProgress } = useMsal();
  const hasStartedSignIn = useRef(false);
  const hasStartedRedirect = useRef(false);

  const signIn = useCallback(async () => {
    if (hasStartedRedirect.current) return;

    hasStartedRedirect.current = true;
    await instance.loginRedirect(loginRequest).catch((e) => {
      hasStartedRedirect.current = false;
      logger.error('sign in error...', e);
    });
  }, [instance]);

  const silentSignIn = useCallback(async () => {
    const request = {
      ...loginRequest,
    };
    try {
      await instance.ssoSilent(request);
    } catch (err) {
      if (
        err instanceof InteractionRequiredAuthError ||
        (err instanceof BrowserAuthError &&
          (err.errorCode === BrowserAuthErrorCodes.monitorWindowTimeout ||
            err.errorCode === BrowserAuthErrorCodes.iframeClosedPrematurely))
      ) {
        await signIn();
      } else {
        logger.error('silent sign-in failed', err);
      }
    }
  }, [instance, signIn]);

  useEffect(() => {
    if (inProgress !== InteractionStatus.None || hasStartedSignIn.current) return;

    hasStartedSignIn.current = true;
    silentSignIn();
  }, [inProgress, silentSignIn]);

  return {
    signIn,
    silentSignIn,
  };
};
